
import VueRouter from "vue-router";
//引入组件
import HomeYjj from "@/components/yjj/HomeYjj";
import HomeYjjM from "@/components/yjj/mobile/HomeYjjM";
import LoginAdmin from "@/components/admin/LoginAdmin";
import HomeAdmin from "@/components/admin/HomeAdmin";
import UserAdmin from "@/components/admin/UserAdmin";
import ArticleAdmin from "@/components/admin/ArticleAdmin";
import ArticleManAdmin from "@/components/admin/ArticleManAdmin";
import ArticleUpdateAdmin from "@/components/admin/ArticleUpdateAdmin";
import ArticleColumn from "@/components/admin/ArticleColumn";
import ArticleVideo from "@/components/admin/ArticleVideo";
import UserDeptAdmin from "@/components/admin/UserDeptAdmin";
import DisplayAdmin from "@/components/admin/DisplayAdmin";
import ArticleContentYjj from "@/components/yjj/ArticleContentYjj";
import MemoryYjj from "@/components/yjj/MemoryYjj";
import AboutYjj from "@/components/yjj/AboutYjj";
import AboutJian from "@/components/yjj/AboutJian";
import AboutHonor from "@/components/yjj/AboutHonor";
import NewsListYjj from "@/components/yjj/NewsListYjj";
import NewsListYjjM from "@/components/yjj/mobile/NewsListYjjM";
import DisplayListYjj from "@/components/yjj/DisplayListYjj";
import ImgContentYjj from "@/components/yjj/ImgContentYjj";
import ResearchListYjj from "@/components/yjj/ResearchListYjj";
import EduListYjj from "@/components/yjj/EduListYjj";
import CulturalAdmin from "@/components/admin/CulturalAdmin";
import CulturalListYjj from "@/components/yjj/CulturalListYjj";
import CulturalContentYjj from "@/components/yjj/CulturalContentYjj";
// import HomeKzhd from "@/components/kzhd/HomeKzhd";
// import KzhdZxjj from "@/components/kzhd/KzhdZxjj";
// import KzhdPxdt from "@/components/kzhd/KzhdPxdt";
// import KzhdJpkc from "@/components/kzhd/KzhdJpkc";
// import KzhdTsal from "@/components/kzhd/KzhdTsal";
// import KzhdPxjd from "@/components/kzhd/KzhdPxjd";
// import KzhdHslx from "@/components/kzhd/KzhdHslx";
// import KzhdLxwm from "@/components/kzhd/KzhdLxwm";
// import KzhdXyfc from "@/components/kzhd/KzhdXyfc";
// import KzhdSzll from "@/components/kzhd/KzhdSzll";
// import KzhdNewsContent from "@/components/kzhd/KzhdNewsContent";
// import HomeLqs from "@/components/lqs/HomeLqs";
// import HomeHsjy from "@/components/hsjy/HomeHsjy";
// import ArticleContentHsjy from "@/components/hsjy/ArticleContentHsjy";
// import NewsListHsjy from "@/components/hsjy/NewsListHsjy";
// import HsjyHsjy from "@/components/hsjy/HsjyHsjy";
// import HswwHsjy from "@/components/hsjy/HswwHsjy";
import YizhiAdmin from "@/components/admin/YizhiAdmin";
// import HsjdHsjy from "@/components/hsjy/HsjdHsjy";
// import HsjdContentHsjy from "@/components/hsjy/HsjdContentHsjy";
// import HsjpHsjy from "@/components/hsjy/HsjpHsjy";
// import ContentLqs from "@/components/lqs/ContentLqs";
// import StoryListLqs from "@/components/lqs/StoryListLqs";
// import DisplayListLqs from "@/components/lqs/DisplayListLqs";
// import LsymLqs from "@/components/lqs/LsymLqs";
// import XjpHszyZhuanTi from "@/components/hsjy/XjpHszyZhuanTi";
import MapYjj from "@/components/yjj/MapYjj.vue";
// import MapLqs from "@/components/lqs/MapLqs";
import YjjAdmin from "@/components/admin/YjjAdmin";
import HomeMinzu from "@/components/minzu/HomeMinzu";
import ContentMinzu from "@/components/minzu/ContentMinzu";
import listMinzu from "@/components/minzu/ListMinzu";
import ArticleContentYjjM from "@/components/yjj/mobile/ArticleContentYjjM";
import MapYjjM from "@/components/yjj/mobile/MapYjjM";
import AboutYjjM from "@/components/yjj/mobile/AboutYjjM";
import DisplayListYjjM from "@/components/yjj/mobile/DisplayListYjjM";
import CulturalListYjjM from "@/components/yjj/mobile/CulturalListYjjM";
import ResearchListYjjM from "@/components/yjj/mobile/ResearchListYjjM";
import MemoryYjjM from "@/components/yjj/mobile/MemoryYjjM";
import ErrorPage from "@/components/hsjy/ErrorPage";
//创建并暴露路由
export default new VueRouter({
    routes:[
        //红色教育服务中心
        // {
        //   path:'/',
        //   name:'HomeHsjy',
        //   component:HomeHsjy,
        //   meta: { title: '红色教育服务中心' }
        // },
        //
        //
        // {
        //     path:'/news',
        //     name:'NewsListHsjy',
        //     component:NewsListHsjy,
        //     meta: { title: '红色教育服务中心' }
        // },
        // {
        //     path:'/hsjy',
        //     name:'HsjyHsjy',
        //     component:HsjyHsjy,
        //     meta: { title: '红色教育服务中心' }
        // },
        // {
        //     path:'/hsww',
        //     name:'HswwHsjy',
        //     component:HswwHsjy,
        //     meta: { title: '红色教育服务中心' }
        // },
        // {
        //     path:'/hsjd',//红色基地
        //     name:'HsjdHsjy',
        //     component:HsjdHsjy,
        //     meta: { title: '红色教育服务中心' }
        // },
        // {
        //     path:'/hsjdcontent/:id',//红色基地内容页
        //     name:'HsjdContentHsjy',
        //     component:HsjdContentHsjy,
        //     meta: { title: '红色教育服务中心' }
        // },
        // {
        //     path:'/article/:id',
        //     name:'ArticleContentHsjy',
        //     component:ArticleContentHsjy,
        //     meta: { title: '红色教育服务中心' }
        // },
        // {
        //     path:'/hsjp',//红色精品
        //     name:'HsjpHsjy',
        //     component:HsjpHsjy,
        //     meta: { title: '红色教育服务中心' }
        // },
        // {
        //     path:'/hszyls',//习近平红色资源专题
        //     name:'XjpHszyZhuanTi',
        //     component:XjpHszyZhuanTi,
        //     meta: { title: '用好红色资源 赓续红色血脉——学习习近平总书记关于红色资源重要论述展' }
        // },
        //义勇军馆部分
        {
            path:'/',
            name:'HomeYjj',
            component:window.innerWidth < 768 ? HomeYjjM : HomeYjj,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        {
            path:'/yjj/article/:id',
            name:'ArticleContentYjj',
            component:window.innerWidth < 768 ?ArticleContentYjjM : ArticleContentYjj,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        {
            path:'/yjj/memory',
            name:'MemoryYjj',
            component:window.innerWidth < 768 ? MemoryYjjM : MemoryYjj,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        {
            path:'/yjj/about',
            name:'AboutYjj',
            component:window.innerWidth < 768 ? AboutYjjM : AboutYjj,
            children:[
                {
                    name:'intro',
                    path:'intro',//文章管理
                    component:AboutJian,
                    meta: { title: '东北抗日义勇军纪念馆' }
                },
                {
                    name:'honor',
                    path:'honor',//文章管理
                    component:AboutHonor,
                    meta: { title: '东北抗日义勇军纪念馆' }
                }
            ],

        },
        {
            path:'/yjj/newslist',
            name:'NewsListYjj',
            component:window.innerWidth < 768 ? NewsListYjjM : NewsListYjj ,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        {
            path:'/yjj/displaylist',
            name:'DisplayListYjj',
            component:window.innerWidth < 768 ? DisplayListYjjM : DisplayListYjj,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        {
            path:'/yjj/cultural',
            name:'CulturalListYjj',
            component:window.innerWidth < 768 ? CulturalListYjjM :CulturalListYjj,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        {
            path:'/yjj/culcont/:id',
            name:'CulturalContentYjj',
            component:CulturalContentYjj,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        {
            path:'/yjj/pic/:id',
            name:'ImgContentYjj',
            component:ImgContentYjj,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        {
            path:'/yjj/xsyj',
            name:'ResearchListYjj',
            component:window.innerWidth < 768 ? ResearchListYjjM :ResearchListYjj,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        {
            path:'/yjj/jyhd',
            name:'EduListYjj',
            component:EduListYjj,
            meta: { title: '东北抗日义勇军纪念馆' }
        },        {
            path:'/yjj/map',
            name:'MapYjj',
            component:window.innerWidth < 768 ? MapYjjM : MapYjj,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        //民族团结
        {
            path:'/yjj/mztj',
            name:'HomeMinzu',
            component:HomeMinzu,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        //民族团结
        {
            path:'/yjj/mztj/:id',//内容页
            name:'ContentMinzu',
            component:ContentMinzu,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        //民族团结
        {
            path:'/yjj/mztj/list/:id',//列表页
            name:'ListMinzu',
            component:listMinzu,
            meta: { title: '东北抗日义勇军纪念馆' }
        },
        // //抗战红都部分
        // {
        //     path:'/kzhd',
        //     name:'HomeKzhd',
        //     component:HomeKzhd,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },
        // {
        //     path:'/kzhd/zxjj',//中心简介
        //     name:'KzhdZxjj',
        //     component:KzhdZxjj,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },
        // {
        //     path:'/kzhd/pxdt',//培训动态
        //     name:'KzhdPxdt',
        //     component:KzhdPxdt,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },
        // {
        //     path:'/kzhd/jpkc',//精品课程
        //     name:'KzhdJpkc',
        //     component:KzhdJpkc,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },
        // {
        //     path:'/kzhd/tsal',//特色案例
        //     name:'KzhdTsal',
        //     component:KzhdTsal,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },
        // {
        //     path:'/kzhd/pxjd',//培训基地
        //     name:'KzhdPxjd',
        //     component:KzhdPxjd,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },
        // {
        //     path:'/kzhd/hslx',//红色路线
        //     name:'KzhdHslx',
        //     component:KzhdHslx,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },
        // {
        //     path:'/kzhd/lxwm',//联系我们
        //     name:'KzhdLxwm',
        //     component:KzhdLxwm,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },
        // {
        //     path:'/kzhd/xyfc',//学员风采
        //     name:'KzhdXyfc',
        //     component:KzhdXyfc,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },
        // {
        //     path:'/kzhd/szll',//师资力量
        //     name:'KzhdSzll',
        //     component:KzhdSzll,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },
        // {
        //     path:'/kzhd/article/:id',//内容页
        //     name:'KzhdNewsContent',
        //     component:KzhdNewsContent,
        //     meta: { title: '桓仁抗战红都教育服务中心' }
        // },

        //李秋实纪念馆部分
        // {
        //     path:'/lqs',//首页
        //     name:'HomeLqs',
        //     component:HomeLqs,
        //     meta: { title: '李秋实纪念馆' }
        // },
        // {
        //     path:'/lqs/article/:id',//内容页
        //     name:'ContentLqs',
        //     component:ContentLqs,
        //     meta: { title: '李秋实纪念馆' }
        // },
        // {
        //     path:'/lqs/storylqs',//内容页
        //     name:'StoryListLqs',
        //     component:StoryListLqs,
        //     meta: { title: '李秋实纪念馆' }
        // },
        // {
        //     path:'/lqs/display',//内容页
        //     name:'DisplayListLqs',
        //     component:DisplayListLqs,
        //     meta: { title: '李秋实纪念馆' }
        // },
        // {
        //     path:'/lqs/lsym',//内容页
        //     name:'LsymLqs',
        //     component:LsymLqs,
        //     meta: { title: '李秋实纪念馆' }
        // },
        // {
        //     path:'/lqs/map',//内容页
        //     name:'MapLqs',
        //     component:MapLqs,
        //     meta: { title: '李秋实纪念馆' }
        // },
        //后台部分
        {
            path:'/admin/hsjy/login',
            component:LoginAdmin
        },
        {
            path:'/admin/hsjy/admin',
            component:HomeAdmin,
            beforeEnter:(to,from,next) =>{
                if(localStorage.getItem('userInfo')) {
                    next();
                }
                else{
                    next('/admin/hsjy/login')
                }
            },
            meta:{title:"红色教育服务中心后台管理系统"},
            children:[
                {
                    path:'users',//
                    component:UserAdmin,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/login')
                        }
                    },
                },
                {
                    name:'usersDept',
                    path:'usersdept',//文章管理
                    component:UserDeptAdmin,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/login')
                        }
                    },
                },
                {
                    path:'articleadd',//新增文章
                    component:ArticleAdmin,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/login')
                        }
                    },
                },
                {
                    name:'articleman',
                    path:'articleman',//文章管理
                    component:ArticleManAdmin,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/login')
                        }
                    },
                },
                {
                    name:'articleupdate',
                    path:'articleupdate',//文章修改
                    component:ArticleUpdateAdmin,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/login')
                        }
                    },
                },
                {
                    name:'articleColumn',
                    path:'articlecolumn',//文章修改
                    component:ArticleColumn,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/login')
                        }
                    },
                },
                {
                    name:'articleVideo',
                    path:'articleVideo',//视频管理
                    component:ArticleVideo,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/login')
                        }
                    },
                },
                {
                    name:'displayAdmin',
                    path:'displayadmin',
                    component:DisplayAdmin,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/login')
                        }
                    },
                },
                {
                    name:'culturalAdmin',
                    path:'culturaladmin',
                    component:CulturalAdmin,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/login')
                        }
                    },
                },
                {
                    name:'yizhiAdmin',//红色基地管理
                    path:'yizhiadmin',
                    component:YizhiAdmin,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/login')
                        }
                    },
                },
                {
                    name:'yjjAdmin',//红色基地管理
                    path:'yjjadmin',
                    component:YjjAdmin,
                    beforeEnter:(to,from,next) =>{
                        if(localStorage.getItem('userInfo')) {
                            next();
                        }
                        else{
                            next('/admin/hsjy/')
                        }
                    },
                },
            ]
        },
        {
            path:'*',
            component:ErrorPage
        },
    ],
    // mode:'history'



});




